import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  landing: {
    overflowX: 'hidden',
  },
  banner: {
    backgroundColor: theme.palette.primary.main,
    marginTop: theme.spacing(-8),
    marginBottom: theme.spacing(3),
    paddingTop: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(4),
      paddingLeft: theme.spacing(8),
      paddingRight: theme.spacing(11),
    },
  },
  bannerSecondBlock: {
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left',
    },
  },
  bannerTitle: {
    color: theme.palette.common.white,
    marginBottom: theme.spacing(2),
    fontSize: 36,
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(5),
    },
  },
  bannerSubtitle: {
    color: theme.palette.common.white,
    marginBottom: theme.spacing(4),
  },
  bannerButton: {
    color: theme.palette.primary.light,
    backgroundColor: theme.palette.primary.lighter,
    marginBottom: theme.spacing(2),
    '&:hover': {
      backgroundColor: theme.palette.primary.lighter,
    },
  },
  feature: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(4),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(9),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
  },
  featureTitle: {
    color: theme.palette.primary.dark,
    marginBottom: theme.spacing(1),
    fontSize: 24,
  },
  featureText: {
    color: theme.palette.grey[200],
    fontSize: 16,
  },
  featureImage: {
    maxWidth: theme.spacing(13),
    marginBottom: theme.spacing(1),
  },
}))

export default useStyles
